import { Component, inject } from '@angular/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import {
  LetpensiondkDokumenterListComponent
} from '@features/letpensiondk/letpensiondk-dokumenter/letpensiondk-dokumenter-list/letpensiondk-dokumenter-list.component';
import {
  LetpensiondkDokumenterDetailComponent
} from '@features/letpensiondk/letpensiondk-dokumenter/letpensiondk-dokumenter-detail/letpensiondk-dokumenter-detail.component';
import { DokumenterService } from '@features/letpensiondk/letpensiondk-dokumenter/dokumenter.service';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-letpensiondk-dokumenter',
  imports: [
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    LetpensiondkDokumenterListComponent,
    LetpensiondkDokumenterDetailComponent,
    Button,
  ],
  templateUrl: './letpensiondk-dokumenter.component.html',
  styleUrl: './letpensiondk-dokumenter.component.css'
})
export class LetpensiondkDokumenterComponent {
  dokumenterService = inject(DokumenterService);
}
